import { useNavigateToRoot } from 'hooks/useNavigateToRoot';
import { ProviderAccountsForm } from 'pages/Finance/ProviderAccounts/components/ProviderAccountsForm/ProviderAccountsForm';
import { SimpleForm, useNotify } from 'react-admin';
import { CancelButton, SaveButtonValidated } from 'shared/mui/Buttons';
import { CardActionsButtons } from 'shared/mui/Card';
import { CreatePage } from 'shared/react-admin/Pages/CreatePage/CreatePage';
import { ProviderAccount } from 'types/embedded/providerAccount';
import { getId } from 'utils/getId';

export const ProviderAccountsCreate: React.FC = () => {
  const { toRoot } = useNavigateToRoot();
  const notify = useNotify();

  async function onSuccess(data: ProviderAccount) {
    notify(`Настройка доступа ID ${getId(data?.id)} создана`, {
      type: 'success',
    });
    toRoot();
  }

  async function onError(error: any) {
    notify(error.message, { type: 'error' });
  }

  return (
    <CreatePage
      listName="Настройки доступа"
      mutationOptions={{ onSuccess, onError }}
      title="Создание настройки доступа"
    >
      <SimpleForm sx={{ '&.MuiCardContent-root': { padding: 0 } }} toolbar={false}>
        <ProviderAccountsForm />
        <CardActionsButtons
          rightActionsSlot={[
            <CancelButton key="cancel-button" variant="outlined" />,
            <SaveButtonValidated key="save-button" />,
          ]}
          sx={{ marginTop: 'auto', padding: 0 }}
        />
      </SimpleForm>
    </CreatePage>
  );
};
